import { useEffect } from 'react';

import { showToast } from '../../utils/tools';
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import { clearNotifications } from '../../store/reducers/notifications';


const Toast = () => {

    const dispatch = useDispatch();


    // Access to state notifications
    const notifications = useSelector(state => state.notifications);

    useEffect(() => {
        // Always listening on notifications
        let { global } = notifications;
        // Detect if we have notification and which type
        if(notifications && global.error) {
            const msg = global.msg ? global.msg : 'Error';
            showToast('ERROR', msg)
            // Clear notifications
            dispatch(clearNotifications());
        }
        if(notifications && global.success) {
            const msg = global.msg ? global.msg : 'Good';
            showToast('SUCCESS', msg)
            dispatch(clearNotifications());
        }
        if(notifications && global.warning) {
            const msg = global.msg ? global.msg : 'Warning';
            showToast('WARNING', msg)
            dispatch(clearNotifications());
        }
    },[notifications, dispatch]);

  

    return(
        <>
            <ToastContainer/>
        </>
    )   
}

export default Toast;
